import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { painPoints, gainPoints } from '../data/content';
export function BeforeAfter() {
  return <section className="border-t border-ink-700 bg-ink-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-35" data-mp="3of82fcw4somr">
      <div className="mx-auto w-full max-w-5xl" data-id="element-36" data-mp="3sg1vekofktmi">
        <SectionHeading eyebrow="Vorher / Nachher" title="Hör auf zu zweifeln, jedes Mal wenn du deine Maschine einschaltest" data-id="element-37" data-mp="3epy9jutgr1xl" />

        <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-38" data-mp="3ji9an0zxwtrq">
          <div className="rounded-2xl border border-bad/25 bg-bad/[0.06] p-5" data-id="element-39" data-mp="34saef3ry3sew">
            <p className="font-display text-lg uppercase tracking-wide text-bad" data-id="element-40" data-mp="39qv7mj8s5btu">Heute…</p>
            <ul className="mt-4 space-y-3" data-id="element-41" data-mp="39oityia21nml">
              {painPoints.map(point => <li key={point} className="flex gap-3" data-id="element-42" data-mp="2vtgbywrxo7tf">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-bad" aria-hidden="true" data-id="element-43" data-mp="30p5i5iygkmyp" />
                  <span className="text-[15px] leading-snug text-white/75" data-id="element-44" data-mp="x3ir4rfbn3mz">{point}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-brand/35 bg-brand/[0.07] p-5" data-id="element-45" data-mp="t5bd44c8sgfh">
            <p className="font-display text-lg uppercase tracking-wide text-brand" data-id="element-46" data-mp="170neuvotf75w">
              Mit dem Meister-System…
            </p>
            <ul className="mt-4 space-y-3" data-id="element-47" data-mp="edj5keiow6ob">
              {gainPoints.map(point => <li key={point} className="flex gap-3" data-id="element-48" data-mp="9f9980l8b014">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-49" data-mp="9gsr1vmj9j50" />
                  <span className="text-[15px] leading-snug text-white" data-id="element-50" data-mp="o5gltzok1otw">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaBlock label="Ich will saubere Schweißnähte" showTimer={false} note="Sofortiger Zugang · Einmalige Zahlung von 19 €" className="mt-8" data-id="element-51" data-mp="3rs73bqvcaynd" />
      </div>
    </section>;
}